'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        cashRefundPNRs: {},
        renderPNRCards: true,
    },
});
